<template>
  <div class="page-content marketing-materials">
    <div class="row">
      <div class="col-sm-12">
        <download-brochure />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import DownloadBrochure from './MarketingMaterials/DownloadBrochure.vue';

export default {
  name: 'MarketingMaterials',

  components: {
    DownloadBrochure,
  },
};
</script>
